import { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  registerUser,
  sendOTP,
  verifyOTP,
} from "../../services/auth_service";

import "./Register.css";

export default function Register() {

  const navigate = useNavigate();

  const [form, setForm] = useState({
    full_name: "",
    email: "",
    mobile: "",
    password: "",
  });

  const [otp, setOtp] = useState("");

  const [showOtpBox, setShowOtpBox] =
    useState(false);

  const [loading, setLoading] =
    useState(false);

  const handleRegister = async (e) => {

    e.preventDefault();

    try {

      setLoading(true);

      await registerUser(form);

      await sendOTP(form.mobile);

      setShowOtpBox(true);

      alert("OTP Sent Successfully");

    } catch (err) {

      alert(
        err?.response?.data?.detail ||
        "Registration Failed"
      );

    } finally {

      setLoading(false);

    }

  };

  const handleVerifyOTP = async () => {

    try {

      await verifyOTP(
        form.mobile,
        otp
      );

      alert("Mobile Verified Successfully");

      navigate("/");

    } catch (err) {

      alert(
        err?.response?.data?.detail ||
        "Invalid OTP"
      );

    }

  };

  return (

    <div className="login-page">

      <div className="login-container">

        {/* LEFT */}

        <div className="login-left">

          <div className="login-left-content">

            <div className="logo-circle">
              🚚
            </div>

            <h2>
              Fleet Management
            </h2>

            <span className="company-text">
              SMART TRANSPORT SOLUTION
            </span>

            <div className="line"></div>

            <p>
              Create your Fleet Management account
              to manage Drivers, Vehicles,
              Suppliers, Vehicle Assignments,
              Fuel Tracking, EMI, Maintenance,
              Reports and much more.
            </p>

            <div className="feature-list">

              <div className="feature-item">
                ✓ Driver Management
              </div>

              <div className="feature-item">
                ✓ Vehicle Management
              </div>

              <div className="feature-item">
                ✓ Supplier Management
              </div>

              <div className="feature-item">
                ✓ Vehicle Assignment
              </div>

              <div className="feature-item">
                ✓ Reports & Dashboard
              </div>

            </div>

          </div>

        </div>
        <div className="login-right">

          <div className="login-card">
            <h2>Create Account</h2>

            <p>
              Register to Fleet Management Portal
            </p>

            <form
              onSubmit={handleRegister}
            >

              <div className="form-group">

                <label>
                  Full Name
                </label>

                <input
                  type="text"
                  placeholder="Enter Full Name"
                  value={form.full_name}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      full_name:
                        e.target.value,
                    })
                  }
                  required
                />

              </div>

              <div className="form-group">

                <label>
                  Email Address
                </label>

                <input
                  type="email"
                  placeholder="Enter Email"
                  value={form.email}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      email:
                        e.target.value,
                    })
                  }
                  required
                />

              </div>

              <div className="form-group">

                <label>
                  Mobile Number
                </label>

                <input
                  type="text"
                  placeholder="Enter Mobile Number"
                  value={form.mobile}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      mobile:
                        e.target.value,
                    })
                  }
                  required
                />

              </div>

              <div className="form-group">

                <label>
                  Password
                </label>

                <input
                  type="password"
                  placeholder="Enter Password"
                  value={form.password}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      password:
                        e.target.value,
                    })
                  }
                  required
                />

              </div>

              {showOtpBox && (

                <div className="form-group">

                  <label>
                    OTP
                  </label>

                  <input
                    type="text"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) =>
                      setOtp(
                        e.target.value
                      )
                    }
                  />

                </div>

              )}

              {!showOtpBox ? (

                <button
                  type="submit"
                  className="login-btn"
                  disabled={loading}
                >

                  {loading
                    ? "Registering..."
                    : "Register"}

                </button>

              ) : (

                <button
                  type="button"
                  className="login-btn"
                  onClick={
                    handleVerifyOTP
                  }
                >
                  Verify OTP
                </button>

              )}

            </form>

            <div className="auth-footer">

              <span>
                Already have an account?
              </span>

              <span
                className="register-link"
                onClick={() =>
                  navigate("/")
                }
              >
                Login
              </span>

            </div>

            <div className="copyright">
              © 2026 Fleet Management System
            </div>

          </div>

        </div>

      </div>

    </div>

  );

}